<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app
               color="#1976d2" dark>
        <v-app-bar-nav-icon v-if="$store.getters.isAuthenticated"
                            @click.stop="drawerChange">
        </v-app-bar-nav-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
            <a href="/" class="hidden-sm-and-down">{{ $t("header.title") }}</a>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <!--@click="logout"-->
            <v-menu v-if="$store.getters.isAuthenticated"
                    offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn text
                           v-on="on"
                    >
                        <avatar color="white" :username="$store.state.user.name" :size="42"></avatar>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item class="v-btn" @click="logout">
                        <v-list-item-title>{{ $t("general.logout") }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn v-else text href="/login">{{ $t("general.login") }}</v-btn>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
    import Avatar from 'vue-avatar'

    export default {
        components: {
            Avatar
        },
        data: () => ({
            drawer: null,
            dialog: false
        }),
        methods: {
            drawerChange() {
                this.drawer = !this.drawer;
                this.$emit('drawer-change', this.drawer);
            },
            async logout() {
                axios.get(`${this.$store.state.api_url}/api/logout`)
                    .then(async response => {
                        // Clear indexedDb storage.
                        await this.$store.state.indexedDbAppStore.clear();
                        await this.$store.state.indexedDbUserStore.clear();

                        // Clear Vuex variables.
                        this.$store.commit('mutateAccessToken', null);
                        this.$store.commit('mutateUser', null);

                        // Clear auth header token
                        this.$store.dispatch('setAuthHeader', {accessToken: ''});

                        this.$router.push('/login');
                    })
                    .catch(error => {
                        this.$store.dispatch('showResponseNotification', {
                            "response": error.response, "timeout": 5000
                        });
                    })
            }
        }
    }
</script>